<app-selector label="Match the column Game" [isEmptySelectable]="isEmptySelectable" [data]="mtcGameCoreService.mtcGameList$| async"
    displayKey="name" [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="mtcGameCoreService.loading"
    [hint]="hint">
</app-selector>